import {ValideringsfeilException} from "../infrastruktur/http/httpErrorResponseTyper";

export function feilkoderFraValideringsfeilExceptionSomIkkeoversattStreng(feil: ValideringsfeilException): string {
   return feilkoderFraValideringsfeilException(feil).join(', ')
}

export function feilkoderFraValideringsfeilException<T>(feil: ValideringsfeilException<T, any>): T[] {
    return feil.error.feil.map(feil => feil.feilkode);
}
